import { render } from "./HorizontalLink.vue?vue&type=template&id=5017f58d&scoped=true"
import script from "./HorizontalLink.vue?vue&type=script&lang=js"
export * from "./HorizontalLink.vue?vue&type=script&lang=js"

import "./HorizontalLink.vue?vue&type=style&index=0&id=5017f58d&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\PeD\\ApontaFacil\\dashboard\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5017f58d"]])

export default __exports__